export const SET_ACCESS_TOKEN = 'setAccessToken'
export const SET_EXPIRES_IN = 'setExpiresIn'
export const SET_TOKEN_TYPE = 'setTokenType'
export const SET_DEFAULT_ORGANIZATION = 'setDefaultOrganization'
export const SET_ACTIVE_ORGANIZATION = 'setActiveOrganization'
export const SET_SPEED_UNIT = 'setSpeedUnit'
export const SET_EMAIL = 'setEmail'
export const SET_GIVEN_NAME = 'setGivenName'
export const SET_FAMILY_NAME = 'setFamilyName'
export const SET_PERMISSIONS = 'setPermissions'
export const SET_USER_ID = 'setUserId'
export const SET_EXPIRATION_ISO_DATE = 'setExpirationIsoDate'
export const SET_USER_SESSION = 'setUserSession'

const setAccessToken = (state, payload) => {
    state.accessToken = payload
}

const setExpiresIn = (state, payload) => {
    state.expiresIn = payload
}

const setTokenType = (state, payload) => {
    state.tokenType = payload
}

const setDefaultOrganization = (state, payload) => {
    state.defaultOrganization = payload
}

const setActiveOrganization = (state, payload) => {
    state.activeOrganization = payload
}

const setSpeedUnit = (state, payload) => {
    state.speedUnit = payload
}

const setEmail = (state, payload) => {
    state.email = payload
}

const setGivenName = (state, payload) => {
    state.givenName = payload
}

const setFamilyName = (state, payload) => {
    state.familyName = payload
}

const setPermissions = (state, payload) => {
    state.permissions = payload
}

const setUserId = (state, payload) => {
    state.user_id = payload
}

const setExpirationIsoDate = (state, payload) => {
    state.expirationIsoDate = payload
}
const setUserSession = (state, payload) => {
    state.userSession = payload
}

export default {
    setAccessToken,
    setExpiresIn,
    setTokenType,
    setDefaultOrganization,
    setActiveOrganization,
    setSpeedUnit,
    setEmail,
    setGivenName,
    setFamilyName,
    setPermissions,
    setUserId,
    setExpirationIsoDate,
    setUserSession
}
